<template>
  <div style="flex: 1; display: flex; flex-direction: column; overflow: hidden; position: relative;">
    <!-- 表格区 -->
    <div style="flex: 1; overflow: auto;">
      <table style="width: 100%; border-collapse: collapse; table-layout: fixed;">
        <thead>
          <tr style="position: sticky; top: 0; background: #ffffff; z-index: 10; height: 48px;">
            <th :style="{ position: 'relative', width: columnWidths.month + 'px', textAlign: 'center', borderBottom: '1px solid #e8e8e8', fontWeight: 600, color: '#333', borderRight: isResizeMode ? '1px solid #1890ff' : '1px solid transparent' }">
              月份
              <span v-if="isResizeMode" style="position: absolute; right: -5px; top: 50%; transform: translateY(-50%); color: #1890ff; font-size: 10px;">➡</span>
              <span v-if="isSortMode" style="margin-left: 4px; cursor: grab; color: #1890ff;">⠿</span>
            </th>
            <th :style="{ position: 'relative', width: columnWidths.rank + 'px', textAlign: 'center', borderBottom: '1px solid #e8e8e8', fontWeight: 600, color: '#333', borderRight: isResizeMode ? '1px solid #1890ff' : '1px solid transparent' }">
              排名
              <span v-if="isResizeMode" style="position: absolute; right: -5px; top: 50%; transform: translateY(-50%); color: #1890ff; font-size: 10px;">➡</span>
              <span v-if="isSortMode" style="margin-left: 4px; cursor: grab; color: #1890ff;">⠿</span>
            </th>
            <th :style="{ position: 'relative', textAlign: 'left', padding: '0 16px', borderBottom: '1px solid #e8e8e8', fontWeight: 600, color: '#333', borderRight: isResizeMode ? '1px solid #1890ff' : '1px solid transparent' }">
              姓名
              <span v-if="isResizeMode" style="position: absolute; right: -5px; top: 50%; transform: translateY(-50%); color: #1890ff; font-size: 10px;">➡</span>
              <span v-if="isSortMode" style="margin-left: 4px; cursor: grab; color: #1890ff;">⠿</span>
            </th>
            <th :style="{ width: columnWidths.count + 'px', textAlign: 'center', borderBottom: '1px solid #e8e8e8', fontWeight: 600, color: '#333' }">
              数量
              <span v-if="isSortMode" style="margin-left: 4px; cursor: grab; color: #1890ff;">⠿</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- 骨架屏 -->
          <template v-if="loading">
            <tr v-for="i in 10" :key="'sk-' + i" style="border-bottom: 1px solid #f0f0f0; height: 48px;">
              <td style="text-align: center;"><div style="width: 20px; height: 12px; background: #f0f0f0; border-radius: 2px; margin: 0 auto;"></div></td>
              <td style="padding: 0 16px; display: flex; align-items: center; gap: 10px;">
                <div style="width: 28px; height: 28px; border-radius: 50%; background: #f0f0f0;"></div>
                <div style="width: 80px; height: 12px; background: #f0f0f0; border-radius: 2px;"></div>
              </td>
              <td style="text-align: center;"><div style="width: 20px; height: 12px; background: #f0f0f0; border-radius: 2px; margin: 0 auto;"></div></td>
            </tr>
          </template>
          <!-- 我的排名置顶行 -->
          <tr v-else-if="mine && mine.rank" style="background: #e6f7ff; border-top: 2px solid #1890ff;">
            <td style="text-align: center; color: #1890ff; font-size: 14px;">{{ currentMonthText }}</td>
            <td style="text-align: center; height: 48px; color: #1890ff; font-weight: 600;">{{ mine.rank }}</td>
            <td style="padding: 0 16px; display: flex; align-items: center; gap: 10px; height: 48px;">
              <img :src="getFileAccessHttpUrl(mine.avatar || 'https://oss.dimoclub.com/avatar/微信图片_20240409171829_1712654320596.jpg')"
                style="width: 28px; height: 28px; border-radius: 50%;" />
              <span style="color: #1890ff; font-weight: 600; font-size: 14px;">{{ mine.realname }}（我）</span>
            </td>
            <td style="text-align: center; color: #1890ff; font-weight: 600;">{{ mine.count }}</td>
          </tr>
          <!-- 数据行 -->
          <tr v-for="(item, index) in pagedList" :key="index"
            style="cursor: pointer; height: 48px; transition: background 0.2s;"
            @mouseover="rowHover = index"
            @mouseout="rowHover = -1"
            :style="{ background: rowHover === index ? '#f5f5f5' : '#fff' }"
          >
            <td style="text-align: center; color: #666; font-size: 14px; border-bottom: 1px solid #e7edf5;">{{ currentMonthText }}</td>
            <td style="text-align: center; color: #666; font-size: 14px; border-bottom: 1px solid #e7edf5;">{{ (ipagination.current - 1) * ipagination.pageSize + index + 1 }}</td>
            <td style="padding: 0 16px; display: flex; align-items: center; gap: 10px; height: 48px; border-bottom: 1px solid #e7edf5;">
              <img :src="getFileAccessHttpUrl(item.avatar || 'https://oss.dimoclub.com/avatar/微信图片_20240409171829_1712654320596.jpg')"
                style="width: 28px; height: 28px; border-radius: 50%;" />
              <span style="color: #333; font-size: 14px;">{{ item.realname }}</span>
            </td>
            <td style="text-align: center; color: #333; font-weight: 600; font-size: 14px; border-bottom: 1px solid #e7edf5;">{{ item.count }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 分页栏 -->
    <div style="padding: 0 16px; flex-shrink: 0; display: flex; justify-content: space-between; align-items: center; border-top: 1px solid #e8e8e8; height: 48px; font-size: 13px;">
      <span style="color: #909399; font-size: 12px;">共 {{ rankList.length }} 人</span>
      <div style="display: flex; align-items: center; gap: 8px; color: #606266;">
        <button
          style="min-width: 30px; height: 30px; border: none; background: #fff; cursor: pointer; color: #606266; font-size: 13px;"
          @click="changePage(ipagination.current - 1)"
          :disabled="ipagination.current <= 1"
          :style="{ opacity: ipagination.current <= 1 ? 0.5 : 1 }"
        >&lt;</button>
        <button
          v-for="page in totalPagesArray" :key="page"
          style="min-width: 30px; height: 30px; border: none; cursor: pointer; font-size: 13px; border-radius: 2px;"
          :style="{
            background: page === ipagination.current ? '#409eff' : '#fff',
            color: page === ipagination.current ? '#fff' : '#606266'
          }"
          @click="changePage(page)"
        >{{ page }}</button>
        <button
          style="min-width: 30px; height: 30px; border: none; background: #fff; cursor: pointer; color: #606266; font-size: 13px;"
          @click="changePage(ipagination.current + 1)"
          :disabled="ipagination.current >= totalPages"
          :style="{ opacity: ipagination.current >= totalPages ? 0.5 : 1 }"
        >&gt;</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { getAction, getFileAccessHttpUrl } from '@/api/manage'
  import eventBus from '@/utils/eventBus'

  export default {
    name: "RankList",
    props: {
      rankType: {
        type: String,
        default: 'new'
      }
    },
    data() {
      return {
        rankList: [],
        mine: {},
        rowHover: -1,
        loading: false,
        currentRankType: 'new',
        ipagination: {
          current: 1,
          pageSize: 10,
          total: 0
        },
        // 调列宽模式状态
        isResizeMode: false,
        columnWidths: {
          month: 120,
          rank: 100,
          name: 'auto',
          count: 120
        },
        // 列排序模式状态
        isSortMode: false,
        columnOrder: ['month', 'rank', 'name', 'count']
      }
    },
    computed: {
      currentMonthText() {
        const now = new Date()
        return `${now.getFullYear()}年${now.getMonth() + 1}月`
      },
      pagedList() {
        const start = (this.ipagination.current - 1) * this.ipagination.pageSize
        return this.rankList.slice(start, start + this.ipagination.pageSize)
      },
      totalPages() {
        return Math.ceil(this.rankList.length / this.ipagination.pageSize) || 1
      },
      totalPagesArray() {
        const arr = []
        for (let i = 1; i <= this.totalPages; i++) arr.push(i)
        return arr
      }
    },
    watch: {
      rankType() {
        this.currentRankType = this.getRankType()
        this.ipagination.current = 1
        this.loadData()
      }
    },
    created() {
      // 从localStorage读取当前二级菜单状态
      this.currentRankType = this.getRankType()
      this.loadData()
      // 监听刷新事件
      eventBus.$on('rank-refresh', this.loadData)
      // 监听工具栏按钮
      eventBus.$on('toolbar-button-click', this.onToolbarButtonClick)
      // 监听进入调列宽/列排序模式
      eventBus.$on('enter-resize-mode', () => { this.isResizeMode = true })
      eventBus.$on('enter-sort-mode', () => { this.isSortMode = true })
      // 监听调列宽保存/取消
      eventBus.$on('resize-save', this.handleResizeSave)
      eventBus.$on('resize-cancel', this.handleResizeCancel)
      // 监听列排序保存/取消
      eventBus.$on('sort-save', this.handleSortSave)
      eventBus.$on('sort-cancel', this.handleSortCancel)
    },
    beforeDestroy() {
      eventBus.$off('rank-refresh', this.loadData)
      eventBus.$off('toolbar-button-click', this.onToolbarButtonClick)
      eventBus.$off('enter-resize-mode')
      eventBus.$off('enter-sort-mode')
      eventBus.$off('resize-save', this.handleResizeSave)
      eventBus.$off('resize-cancel', this.handleResizeCancel)
      eventBus.$off('sort-save', this.handleSortSave)
      eventBus.$off('sort-cancel', this.handleSortCancel)
    },
    methods: {
      getFileAccessHttpUrl,
      onToolbarButtonClick(key) {
        if (key === 'refresh') {
          this.loadData()
        } else if (key === 'resize') {
          this.isResizeMode = true
        } else if (key === 'sort') {
          this.isSortMode = true
        }
      },
      handleResizeSave() {
        this.isResizeMode = false
      },
      handleResizeCancel() {
        this.isResizeMode = false
      },
      handleSortSave() {
        this.isSortMode = false
      },
      handleSortCancel() {
        this.isSortMode = false
      },
      getRankType() {
        // 优先从props读取，其次从localStorage读取
        const local = localStorage.getItem('rankActiveSubMenu')
        if (local === 'rank-wait') return 'wait'
        if (local === 'rank-hold') return 'hold'
        if (local === 'rank-customer') return 'customer'
        if (this.rankType) return this.rankType
        return 'new'
      },
      changePage(p) {
        if (p < 1 || p > this.totalPages) return
        this.ipagination.current = p
      },
      loadData() {
        // 每次加载前都从localStorage读取最新状态
        this.currentRankType = this.getRankType()
        this.loading = true
        const done = () => { this.loading = false }
        if (this.currentRankType === 'new') {
          getAction("/api/rankApi/selectWorkorderRankList").then(res => {
            if (res.success) {
              this.mine = res.result.mine
              this.rankList = [...res.result.rankList]
              this.ipagination.total = this.rankList.length
            }
          }).finally(done)
        } else if (this.currentRankType === 'wait') {
          getAction("/api/rankApi/selectWaitRankList", { status: 1 }).then(res => {
            if (res.success) {
              this.mine = res.result.mine
              this.rankList = [...res.result.rankList]
              this.ipagination.total = this.rankList.length
            }
          }).finally(done)
        } else if (this.currentRankType === 'hold') {
          getAction("/api/rankApi/selectWaitRankList", { status: 4 }).then(res => {
            if (res.success) {
              this.mine = res.result.mine
              this.rankList = [...res.result.rankList]
              this.ipagination.total = this.rankList.length
            }
          }).finally(done)
        } else if (this.currentRankType === 'customer') {
          // 本月账号开通数量（平台挂靠数）
          const month = new Date().toISOString().slice(0, 7) // 当前月，格式yyyy-MM
          getAction("/dm/dmDriverPlatform/selectDriverPlatformRankList", { month: month }).then(res => {
            if (res.success) {
              const list = res.result || []
              this.rankList = list.map((item, index) => ({
                realname: item.realname,
                avatar: item.avatar,
                count: item.platformCount
              }))
              // 从数组里找isMine==1的作为我的排名
              const mineIndex = list.findIndex(item => item.isMine == 1)
              if (mineIndex >= 0) {
                const mineItem = list[mineIndex]
                this.mine = {
                  rank: mineIndex + 1,
                  realname: mineItem.realname,
                  avatar: mineItem.avatar,
                  count: mineItem.platformCount
                }
              } else {
                this.mine = {}
              }
              this.ipagination.total = this.rankList.length
            }
          }).finally(done)
        }
      }
    }
  }
</script>
